// Single source of truth for the Crucial Conversation text-field questions:
// their order and their displayed labels. The new form, the detail view, and
// the print view all map over this list so the wording and order can never
// drift between surfaces again (that drift is exactly how "Options You've
// Considered" vs "Options Considered" happened).
//
// Labels and order match the old Bubble platform's form, as supplied by the
// operator on 2026-06-29. "Share a few sentences that describe your business"
// (describe_biz) is the first question, before Topic / Issue. Only topic_issue
// is required.
//
// - `name`     snake_case key used for the form field id and form.data / errors
//              (the controller permits these snake_case params).
// - `prop`     camelCase key used to read the serialized value on the detail
//              and print views (serialize_cc_detail returns camelCase).
// - `label`    the displayed question text.
// - `required` only topic_issue is required.
export const CRUCIAL_CONVERSATION_FIELDS = [
  {
    name: "describe_biz",
    prop: "describeBiz",
    label: "Share a few sentences that describe your business",
    required: false,
  },
  {
    name: "topic_issue",
    prop: "topicIssue",
    label: "Topic / Issue",
    required: true,
  },
  {
    name: "why_crucial",
    prop: "whyCrucial",
    label: "Why this is crucial for me / my business",
    required: false,
  },
  {
    name: "options",
    prop: "options",
    label: "Options / decisions considered up to this point",
    required: false,
  },
  {
    name: "relevant_verses",
    prop: "relevantVerses",
    label: "Relevant Bible verses / principles",
    required: false,
  },
  {
    name: "specific_questions",
    prop: "specificQuestions",
    label:
      "Specific question / issue for the cohort group to help me address / solve",
    required: false,
  },
  {
    name: "how_know",
    prop: "howKnow",
    label: "How I will know I received great input / counsel",
    required: false,
  },
]
